/**
 * 自定义 提示框( Toast )组件
 */
var Toast = {};
var showToast = false, // 存储toast显示状态
  showLoad = false, // 存储loading显示状态
  toastVM = null, // 存储toast vm
  loadNode = null; // 存储loading节点元素
 
Toast.install = function (Vue, options) {
  // 参数
  var opt = {
    defaultType: 'bottom',
    duration: '2500',
    wordWrap: false
  };
  for (var property in options) {
    opt[property] = options[property];
  }
 
  Vue.prototype.$toast = function (tips, type) {
    var curType = type ? type : opt.defaultType;
    var wordWrap = opt.wordWrap ? 'lx-word-wrap' : '';
    var style = opt.width ? { width: opt.width } : {};
  
    if (showToast) return;
  
    if (!toastVM) {
      var toastTpl = Vue.extend({
        data: function () {
          return {
            show: showToast,
            tip: tips,
            type: 'lx-toast-' + curType,
            wordWrap: wordWrap,
            customStyle: style
          };
        },
        render: function (h) {
          return h('div', {
            class: ['lx-toast', this.wordWrap, this.type],
            style: this.customStyle,
            directives: [{ name: 'show', value: this.show }]
          }, this.tip);
        }
      });
      toastVM = new toastTpl();
      var tpl = toastVM.$mount().$el;
      document.body.appendChild(tpl);
    }
  
    toastVM.type = 'lx-toast-' + curType;
    toastVM.tip = tips;
    toastVM.show = showToast = true;
  
    setTimeout(function () {
      toastVM.show = showToast = false;
    }, opt.duration);
  };
 
  ['bottom', 'center', 'top'].forEach(function (type) {
    Vue.prototype.$toast[type] = function (tips) {
      return Vue.prototype.$toast(tips, type)
    }
  });
 
  Vue.prototype.$loading = function (tips, type) {
    if (type == 'close') {
      loadNode.show = showLoad = false;
      return;
    }
    if (showLoad) return;
  
    var loadTpl = Vue.extend({
      data: function () {
        return { show: showLoad, tip: tips };
      },
      render: function (h) {
        var leaves = [];
        for (var i = 0; i < 12; i++) {
          leaves.push(h('div', { class: 'loading_leaf loading_leaf_' + i }));
        }
        return h('div', {
          class: 'lx-load-mark',
          directives: [{ name: 'show', value: this.show }]
        }, [
          h('div', { class: 'lx-load-box' }, [
            h('div', { class: 'lx-loading' }, leaves),
            h('div', { class: 'lx-load-content' }, this.tip)
          ])
        ]);
      }
    });
  
    loadNode = new loadTpl();
    var tpl = loadNode.$mount().$el;
    document.body.appendChild(tpl);
    loadNode.show = showLoad = true;
  };
 
  ['open', 'close'].forEach(function (type) {
    Vue.prototype.$loading[type] = function (tips) {
      return Vue.prototype.$loading(tips, type)
    }
  });
}
 
// 向外暴露接口
module.exports = Toast;
